import axios from '../../../axios'

// 获取列表
export const list = (data) => {
  return axios({
    url: '/basic/feePerson/list',
    method: 'post',
    data
  })
}

// 查看
export const view = (data) => {
  return axios({
    url: '/basic/feePerson/view',
    method: 'post',
    data
  })
}
// 查看
export const edit = (data) => {
  return axios({
    url: '/basic/feePerson/edit',
    method: 'post',
    data
  })
}
// 保存
export const save = (data) => {
  return axios({
    url: '/basic/feePerson/save',
    method: 'post',
    data
  })
}
// 删除
export const doDelete = (data) => {
  return axios({
    url: '/basic/feePerson/delete',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/basic/feePerson.js